import React from 'react';
import { UserAddOutlined } from '@ant-design/icons';
import {
    Input,
    Select,
    Button,
    InputSizes,
    SelectSizes,
} from '@clockout-dev/design-elements';
import SectionCard from '../../common/sectionCard/SectionCard';
import styles from '../styles/team.module.scss';
import FormError from '../../common/formError/FormError';

function InviteTeamMembersCard({
    email,
    role,
    roleOptions,
    onEmailChange,
    onRoleChange,
    onSubmit,
    loading,
    errorMessage,
}) {
    const hasError = Boolean(errorMessage);

    return (
        <SectionCard icon={<UserAddOutlined />} title="Invite Team Members">
            <form className={styles.inviteForm} onSubmit={onSubmit} noValidate>
                <FormError id="invite-email-error" error={errorMessage} />

                <Input
                    size={InputSizes.SMALL}
                    id="invite-email"
                    type="email"
                    label="Email"
                    placeholder="name@yourbank.com"
                    value={email || ''}
                    onChange={(e) => onEmailChange && onEmailChange(e.target.value)}
                    autoComplete="email"
                    status={hasError ? 'error' : ''}
                    aria-invalid={hasError || undefined}
                    aria-describedby={hasError ? 'invite-email-error' : undefined}
                />

                <Select
                    size={SelectSizes.SMALL}
                    id="invite-role"
                    label="Assign Role"
                    value={role || 'Member'}
                    options={roleOptions}
                    onChange={(value) => onRoleChange && onRoleChange(value)}
                />

                <Button
                    type="submit"
                    disabled={loading}>
                    {loading ? 'Sending...' : 'Send Invite'}
                </Button>
            </form>
        </SectionCard>
    );
}

export default InviteTeamMembersCard;
